import React from 'react'
import {TimeAgoIfRecent} from "../../../components/TimeAgoIfRecent";

export default function ({date, className, ...props}) {
  return <small className={`post-time ${className || ''}`} {...props}>
    <TimeAgoIfRecent date={date} minDays={1}/>
  </small>
}

